import { routerSlice } from "../../slices/router";
import { errorModalSlice } from "../../slices/errorModal";
export { handleGeneralError };
function handleGeneralError(dispatch) {
  var errorType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'general_error';
  dispatch(errorModalSlice.actions.setErrorType(errorType));
  dispatch(routerSlice.actions.changeRoute('general_error'));
}